export default __webpack_public_path__ + "static/media/wt.343cc386.png";